import { Link } from "react-router-dom";
import { genres, siteName } from "@/mocks/comics";

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-heart-3-fill text-lg"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">{siteName}</span>
            </div>
            <p className="mt-4 text-sm text-background-200/80 leading-relaxed">
              恋爱、后宫、暧昧、同居、校园、逆后宫题材漫画的追更专区，分类清晰，更新及时，陪你追更不迷路。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-100 hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-weibo-fill"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-100 hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-bilibili-fill"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-100 hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-wechat-fill"></i>
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-3 text-sm text-background-200/80">
              <li><Link to="/" className="hover:text-primary-300 transition-colors">首页</Link></li>
              <li><Link to="/category" className="hover:text-primary-300 transition-colors">分类专区</Link></li>
              <li><Link to="/about" className="hover:text-primary-300 transition-colors">关于我们</Link></li>
              <li><Link to="/contact" className="hover:text-primary-300 transition-colors">联系我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-background-50 mb-4">题材分类</h3>
            <ul className="space-y-3 text-sm text-background-200/80">
              {genres.map((g) => (
                <li key={g.id}>
                  <Link to={`/category?genre=${g.id}`} className="hover:text-primary-300 transition-colors">
                    {g.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-background-50 mb-4">联系与建议</h3>
            <ul className="space-y-3 text-sm text-background-200/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-300"></i>
                <span>contact@xiuxiu-comic.example.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-300"></i>
                <span>每日更新，追更提醒</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-message-3-line text-primary-300"></i>
                <span>欢迎投稿与反馈</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300/70">
          <p>© {new Date().getFullYear()} {siteName} 版权所有。本站内容仅供学习交流，版权归原作者所有。</p>
          <p className="flex items-center gap-1">
            <i className="ri-heart-line text-primary-400"></i>
            用心做好每一个恋爱故事
          </p>
        </div>
      </div>
    </footer>
  );
}